import React, { useState, useEffect } from 'react';
import { Table, Pagination, Checkbox } from 'antd';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { set } from 'immutable';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { Input } from 'antd';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import { useForm, Controller, Feedback } from 'react-hook-form';
import DatePicker from 'react-datepicker';





import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import { URL_EMPLOYEE } from '../../constans/servidor';
import PaginationComponent from './pagination';

const TableComponent = props => {
  const { data, datos } = props;
  const [loadingData, setLoadingData] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [placa, setPlaca] = useState();
  const [placass, setPlacass] = useState();
  const [estado, setEstado] = useState();
  const [fecha_hora, setFecha_hora] = useState([]);
  const [nom_terminal, setNom_terminal] = useState();
  const [cod_terminal, setCod_terminal] = useState();
  const [cod_park, setCod_park] = useState();
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [buscar, setBuscar] = useState(data);
  const [dplaca, setdPlaca] = useState([]);
  const [dplaca1, setdPlaca1] = useState([]);
  const [dplaca2, setdPlaca2] = useState([]);
  const [dataPagination, setDataPagination] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [objeto, setObjeto] = useState([]);
  const [crear, setCrear] = useState(false);




  let handleSearch = ''
  let handleRowClick = ''
  let filteredData = ''

  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const regExpCarro = /^[a-z A-Z]{3}[0-9]{3}$/;
  const regExpCarroR = /^[a-z A-Z]{1}[0-9]{4}$/;
  const regExpCarroA = /^[a-z A-Z]{2}[0-9]{4}$/;
  const regExpCarroV = /^[a-z A-Z]{1}[0-9]{5}$/;
  const regExpMoto = /^[a-z A-Z]{3}[0-9]{2}[a-z A-Z]{1}$/;
  const regExpMotoAntigua = /^[a-z A-Z]{3}[0-9]{2}$/;
  const regExpBici = /^BICI[0-9]{3}$/;
  const regExpBici2 = /^BICI[0-9]{2}$/;


  const verificarPlaca = (placa) => {
    console.log(placa);
    if (
      regExpCarro.test(placa) ||
      regExpCarroR.test(placa) ||
      regExpCarroA.test(placa) ||
      regExpCarroV.test(placa) ||
      regExpMoto.test(placa) ||
      regExpMotoAntigua.test(placa) ||
      regExpBici.test(placa) ||
      regExpBici2.test(placa)
    ) {
      setPlaca(true);
    } else {
      setPlaca(false);
    }
  };

  let resultado = [];

  useEffect(() => {
    setFilterData(data);
    setTimeout(() => {
      setEstado(1)
    }, 800);
  }, [data]);

  const confirmar = async (data) => {


    console.log(objeto);
    setModal(false)

    const parametros = {
      placa: placa,
      cod_park: cod_park
    }
    try {
      function reloadPage() {
        window.location.reload();
      }
      console.log(parametros);
      const resultado = await axios.post(`${URL_EMPLOYEE}/desenganchadas/solicitudEnganchada`, objeto)
      if (resultado.data['status']) {
        toast.success(resultado.data['data'])
        setInterval(reloadPage, 2000);
      } else {
        toast.error(resultado.data['data'])

      }

    } catch (error) {
      toast.error('Algo salio mal..');
      setLoadingData(false);
    }

  }

  console.log(data);

  let valores = dataPagination[0];
  const agregar = (data) => {
    console.log(valores);
    var fechaSeleccionada = new Date(data.fecha);
    let fechaFormateada = fechaSeleccionada.toISOString()
    let fechaCompleta = fechaFormateada.replace('T', ' ').slice(0, -5);
    let miObjeto
    const placas = data.placa
    miObjeto = {
      placa: placas.toUpperCase(),
      estado: ' ',
      cod_park: valores.cod_park,
      fecha_hora: fechaCompleta,
      nombre_park: valores.nombre_park,
      cod_terminal: valores.cod_terminal,
      contrato: ' ',
    };

    setDataPagination([...dataPagination, miObjeto])
  }



  const almacenar = async (data) => {

    let miObjeto

    setModal1(false)
    miObjeto = { // creas un objeto
      cod_park: cod_park,
      placa: dplaca2,
      solicitadoPor: data.nombre,
      concepto: data.descripcion.value,
      observaciones: data.observacion,
      fechaEnganchada: fecha_hora
    };

    setObjeto([...objeto, miObjeto]);
    reset({
      descripcion: '',
      observacion: ''
    })


  }
  handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const eliminarPorPlaca = (placa) => {
    const nuevoObjeto = objeto.filter((item) => item.placa !== placa);
    console.log(nuevoObjeto);
    setObjeto(nuevoObjeto);
  };
  handleRowClick = (row) => {
    const isSelected = selectedRows.includes(row);
    setSelectedRows(isSelected
      ? selectedRows.filter((selectedRow) => selectedRow !== row)
      : [...selectedRows, row]
    );
    setdPlaca2(row.placa)
    if (isSelected) {

      if (dplaca.includes(row.placa)) {
        const newDplaca = dplaca.filter((placa) => placa !== row.placa);
        const newDfecha = dplaca.filter((fecha) => fecha !== row.fecha_hora);

        setdPlaca(newDplaca);
        setdPlaca1("-" + newDplaca + " ");
        // setFecha_hora(newDfecha)
        console.log('entre');
        eliminarPorPlaca(dplaca2)
      }
    } else {
      setModal1(true)
      if (!dplaca.includes(row.placa)) {
        const newDplaca = [...dplaca, row.placa];
        const newDfecha = [...fecha_hora, row.fecha_hora];

        setdPlaca(newDplaca);
        // setFecha_hora(newDfecha)
        setdPlaca1("-" + newDplaca + " ");

      }
    }
    setNom_terminal(row.nombre_park)
    setCod_terminal(row.cod_terminal)
    setCod_park(row.cod_park)
    setFecha_hora(row.fecha_hora)

  };

  filteredData = dataPagination.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  let filteredResults = filteredData;
  let valor

  if (filteredResults.length === 0) {
    valor = true
  }



  return (
    <div>
      {data ? (
        <>
          <Row className="justify-content-end mbottom-40" >
            <input className='buscar inputplaca' type="text" placeholder="Search..." onChange={handleSearch} />
          </Row>
          <table className='tabla '>
            <thead>
              <tr>
                <th></th>
                <th>Parqueadero</th>
                <th>Terminal</th>
                <th>Placa</th>
                <th>Cod de Parqueadero</th>
                <th>Contrato</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row) => (
                <tr key={row.id} onClick={() => handleRowClick(row)}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(row)}
                      onChange={() => handleRowClick(row)}
                    />
                  </td>
                  <td>{row.nombre_park}</td>
                  <td>{row.cod_terminal}</td>
                  <td>{row.placa}</td>
                  <td>{row.cod_park}</td>
                  <td>{row.contrato}</td>
                  <td>{row.fecha_hora}</td>

                </tr>
              ))}
            </tbody>
          </table>
          <div className="float-right pagination">
            <PaginationComponent
              data={data}
              setDataPagination={setDataPagination}
              title="Posts"
              pageLimit={0}
              dataLimit={5000}
            />
          </div>
        </>
      ) : null}
      {valor ? (
        <>
          <form onSubmit={handleSubmit(agregar)}>
            <Row className='mtop-40 mbottom-40'>
              <Col xs={12} sm={6} md={4} lg={4} xl={4}>
                <Form.Group className="inputplaca">
                  <Form.Label className='texto-label'>
                    Placa<span>Ingrese solo numeros y letras</span>
                  </Form.Label>
                  <Controller
                    name="placa"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'El campo es obligatorio',
                      }
                    }}
                    defaultValue=""
                    render={({ field: { onChange, onBlur, value } }) => (
                      <Form.Control
                        type="text"
                        onBlur={onBlur}
                        onChange={(value) => {
                          onChange(value);
                          verificarPlaca(value.target.value);
                        }
                        }
                        value={value}

                      />
                    )}
                  />
                  {errors.placa && (
                    <Form.Text id="passwordHelpBlock" className="error">
                      {errors.placa.message}
                    </Form.Text>
                  )}
                  {!placa && (
                    <Form.Text id="passwordHelpBlock" className="error">
                      Ingrese una placa valida
                    </Form.Text>
                  )}
                </Form.Group>

              </Col>
              <Col xs={12} sm={6} md={4} lg={4} xl={4}>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className='texto-label'>Fecha de Enganche</Form.Label>
                  <Controller
                    name="fecha"
                    control={control}
                    rules={{ required: true }}
                    defaultValue={new Date()}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <DatePicker
                        className="form-control"
                        selected={value}
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        onChange={(date) => onChange(date)}
                      />
                    )}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                <Button type='submit' className=" btn btn-primary mtop-20 boton"
                >
                  Agregar
                </Button>
              </Col>
            </Row>
          </form>
        </>
      ) : null}
      <Row className="btn-flotante float-right justify-content-end mtop-40 mbottom-20">
        <Button onClick={() => { setModal(true) }} type="buttom" variant="primary" className=" btn btn-primary mtop-20 boton"
        >
          Consultar
        </Button>
      </Row>
      <Modal show={modal} onHide={() => setModal(false)} size="lg">
        <form onSubmit={handleSubmit(confirmar)}>
          <Modal.Header closeButton>
            <Modal.Title className='texto-slogan2'>Confirmación de Solicitud Desenganche</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <>
              <form onSubmit={handleSubmit(confirmar)}>
                <Row className="align-items-center">
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <p>Esta seguro de Desenganchar las siguientes placas del parqueadero <span className='texto-resaltado'>{nom_terminal}</span>  </p>
                  </Col>
                </Row>
                <Row>
                  <Col className=" mbottom-40 texto-resaltado" xs={12} sm={12} md={12} lg={12} xl={12} >
                    {dplaca1}


                  </Col>
                </Row>
              </form>

            </>
          </Modal.Body>
          <Modal.Footer>
            <Button type='submit' onClick={() => { setModal(false) }} variant="secondary">Atras</Button>
            <Button type='submit' className=' btn2 btn2-primary  boton' variant="primary">Solicitar Desenganche</Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal show={modal1} onHide={() => setModal(false)} size="lg">
        <form onSubmit={handleSubmit(almacenar)}>
          <Modal.Header closeButton>
            <Modal.Title className='texto-slogan2'>Formulario de Solicitud</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <>
              <Row className="align-items-center">
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <p>Parqueadero <span className='texto-resaltado'>{nom_terminal}</span>  </p>
                </Col>
              </Row>
              <Row>
                <Col className=" mbottom-40 texto-resaltado" xs={12} sm={12} md={12} lg={12} xl={12} >
                  {dplaca2}

                </Col>
              </Row>

              <form onSubmit={handleSubmit(almacenar)}>
                <Row>

                  <Col xs={12} sm={6} md={4} lg={4} xl={4}>
                    <Form.Group controlId="formBasicEmail">
                      <Form.Label className='texto-label'>Concepto</Form.Label>
                      <Controller
                        name="descripcion"
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: 'El campo es obligatorio',
                          }
                        }}
                        defaultValue=''
                        render={({ field: { onChange, onBlur, value } }) => (
                          <Select
                            onChange={(data) => {
                              onChange(data);
                            }}
                            value={value}
                            placeholder="Elige una opción"
                            options={[
                              { value: 'Autorizado', label: "Autorizado" },
                              { value: 'Beparking', label: "Beparking" },
                              { value: 'Cobro Manual', label: "Cobro Manual" },
                              { value: 'Descuento Nomina', label: "Descuento Nomina" },
                              { value: 'Falla del Sistema', label: "Falla del Sistema" },
                              { value: 'Falla de Energia', label: "Falla de Energi" },
                              { value: 'Funcionario', label: "Funcionario" },
                              { value: 'Operario', label: "Operario" },
                              { value: 'Gopass', label: "Gopass" },
                              { value: 'Mensuaidad', label: "Mensuaidad" },
                              { value: 'Ruedaz', label: "Ruedaz" },
                              { value: 'Sobrante', label: "Sobrante" },
                              { value: 'Tarea', label: "Tarea" },
                              { value: 'Placa mal Digitada', label: "Placa mal Digitada" }

                            ]}
                          />

                        )}
                      />
                      {errors.descripcion && (
                        <Form.Text id="passwordHelpBlock" className="error">
                          {errors.descripcion.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4} xl={4}>
                    <Form.Group className="inputmayuscula">
                      <Form.Label className='texto-label'>Nombre Solicitante</Form.Label>
                      <Controller
                        name="nombre"
                        control={control}

                        defaultValue="Sandra Rodriguez"
                        render={({ field: { onChange, onBlur, value } }) => (
                          <Form.Control
                            type="text"
                            onBlur={onBlur}
                            onChange={(value) => onChange(value)}
                            value={value}
                            disabled={true}
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                    <Form.Group controlId="formBasicPassword">
                      <Form.Label className='texto-label'>Observación </Form.Label>
                      <Controller
                        name="observacion"
                        control={control}
                        render={({ field: { onChange, onBlur, value } }) => (
                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Escribe tu mensaje"
                            onChange={(value) => onChange(value)}
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </form>
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => { setModal1(false) }} variant="secondary">Atras</Button>
            <Button type='submit' className=' btn2 btn2-primary  boton' variant="primary">Agregar</Button>
          </Modal.Footer>
        </form>
      </Modal>

    </div>
  );
};

export default TableComponent;
